var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 62,
    height: 38,
    fill: "#5c9e31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 18,
    width: 18,
    height: 18,
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0,
    paintOrder: "normal"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.9199 0 0 .9196 1.096 1.101)",
    fill: "#5c9e31",
    fillRule: "evenodd",
    stroke: "#5c9e31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.087,
    d: "m15.11 21.88 1.551 4.147 4.423 0.1933-3.465 2.756 1.183 4.266-3.692-2.443-3.692 2.443 1.183-4.266-3.465-2.756 4.423-0.1933z",
    paintOrder: "normal"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 62,
    height: 38,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.10f89117a6b50c5c47e357f03c8b2280.svg";
export { ForwardRef as ReactComponent };